export const primerasLetrasMayusculas = (str) => {

    let frase = str.toLowerCase()

    let fraseMin = frase.toLowerCase();

    // Dividir la frase en un array de palabras
    let palabras = fraseMin.split(' ');

    // Iterar sobre cada palabra para capitalizar la primera letra
    let palabrasCapitalizadas = palabras.map(function(palabra) {
        return palabra.charAt(0).toUpperCase() + palabra.slice(1);
    });

    // Unir las palabras de nuevo en una sola frase
    return palabrasCapitalizadas.join(' ');
}